(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["welcome-offer"]) return;
  try {
    
  if (!customElements.get('vf-welcome-offer')) {
    customElements.define('vf-welcome-offer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('[data-vf-welcome-open]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.dismissKey = 'vf-welcome-10-dismissed';
        this.successKey = 'vf-welcome-10-joined';
        this.pendingKey = 'vf-welcome-10-form';
        this.editor = this.dataset.editor === 'true';
        this.hasSuccess = Boolean(document.querySelector('[data-vf-welcome-success]'));
        const pending = this.readStorage('sessionStorage', this.pendingKey);
        const submittedInPopup = pending === 'VidaWelcomePopupForm' || location.hash === '#VidaWelcomePopupForm';
        const popupResult = this.dialog.querySelector('[data-vf-welcome-success], [data-vf-welcome-error]');
        if (this.hasSuccess && !this.editor) this.writeStorage('localStorage', this.successKey, Date.now());
        const joined = Number(this.readStorage('localStorage', this.successKey));
        this.tab.hidden = this.dataset.tab !== 'true' || Boolean(joined) || this.hasSuccess;
        document.addEventListener('click', (event) => {
          const opener = event.target.closest('[data-vf-welcome-open]');
          if (opener) { event.preventDefault(); this.open(opener); }
          const anchor = event.target.closest('[data-vf-welcome-anchor]');
          if (anchor) {
            clearTimeout(this.timer);
            if (!this.editor) this.writeStorage('localStorage', this.dismissKey, Date.now());
            const signup = document.getElementById('VidaWelcomeSignup');
            if (!signup) { event.preventDefault(); this.open(anchor); }
          }
        }, { signal });
        this.querySelectorAll('[data-vf-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), { signal }));
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('vf-welcome-is-open');
          if (!this.editor) this.writeStorage('localStorage', this.dismissKey, Date.now());
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, { signal });
        document.addEventListener('submit', (event) => {
          if (!event.target.matches('[data-vf-welcome-form]')) return;
          clearTimeout(this.timer);
          this.writeStorage('sessionStorage', this.pendingKey, event.target.id);
        }, { signal });
        document.addEventListener('shopify:section:select', (event) => {
          if (event.target.contains(this)) this.open();
        }, { signal });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.target.contains(this) && this.dialog.open) this.dialog.close();
        }, { signal });
        if (submittedInPopup && popupResult) {
          this.open();
          popupResult.focus({ preventScroll: true });
        } else {
          const dismissed = Number(this.readStorage('localStorage', this.dismissKey));
          const days = Number(this.dataset.days) || 7;
          const recentlyDismissed = dismissed && Date.now() - dismissed < days * 86400000;
          if (this.dataset.auto === 'true' && !this.editor && !joined && !recentlyDismissed && !this.hasSuccess && !document.querySelector('[data-vf-welcome-error]') && !location.hash.includes('VidaWelcome')) this.scheduleOpen();
        }
        if (popupResult || this.hasSuccess) this.writeStorage('sessionStorage', this.pendingKey, '');
      }
      scheduleOpen() {
        this.timer = setTimeout(() => {
          if (!this.isConnected) return;
          if (document.hidden || document.querySelector('dialog[open], .mobile-nav[open]') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) {
            this.scheduleOpen();
            return;
          }
          this.open();
        }, Math.max(45, Number(this.dataset.delay) || 45) * 1000);
      }
      open(opener) {
        clearTimeout(this.timer);
        if (this.dialog.open) return;
        this.opener = opener || document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('vf-welcome-is-open');
      }
      readStorage(storage, key) {
        try { return window[storage].getItem(key); } catch { return null; }
      }
      writeStorage(storage, key, value) {
        try { window[storage].setItem(key, String(value)); } catch {}
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('vf-welcome-is-open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
